module.exports = __webpack_public_path__ + "img/20230706095043.2114dd3e.png";